import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import SuperAdminPageLayout from '../../../layout/SuperAdminPageLayout';
const SuperAdminEditEditorPage = () => {
    const { t } = useTranslation();
    const { id, editor } = useParams();
    return (_jsx(SuperAdminPageLayout, { title: t('admin.edit_editor'), unitIid: editor, formType: 'edit', unit: 'editor', institutionId: id }));
};
export default SuperAdminEditEditorPage;
